import { render, staticRenderFns } from "./ViewRefundView.vue?vue&type=template&id=595e84e8"
import script from "./ViewRefundView.vue?vue&type=script&lang=js"
export * from "./ViewRefundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports